import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { Button } from '../../Atoms/Button';
import { Icon } from '../../Atoms/Icon';

import Modal from './Modal';

const ConfirmModal = ({
  onAction,
  onHide,
  children,
  actionText = 'Save',
  headerText = 'Are you sure?',
}) => {
  return (
    <Modal headerText={headerText} onHide={onHide} show>
      <div className="text-center pt-0">
        <div className="pb-5">
          <div>
            <Icon name="danger-filled" className="text-orange h2" />
          </div>
          <div>{children}</div>
        </div>
        <Row className="align-items-center pb-2">
          <Col className="text-center">
            <Button variant="link" className="mr-2" onClick={onHide}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onAction}>
              {actionText}
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,
  children: PropTypes.node,
  actionText: PropTypes.string,
  headerText: PropTypes.string,
};
export default ConfirmModal;
